import type { Card } from '../../types';

/** Pool fuel (ADR-0015 §2, §17). A `die` card is 1×1 with empty cost/effects and
 * no trap; equipping one adds a die to the owner's pool (engine `isDieCard`). */
export const EXTRA_DIE: Card = {
  id: 'extra-die',
  name: 'Die',
  type: 'die',
  rarity: 'common',
  size: { w: 1, h: 1 },
  cost: [],
  effects: [],
};
